import { FC } from "react";
import { Link } from "react-router-dom";

type Card = {
    id: string;
    title: string;
};

type Props = {
    cards: Card[];
    baseUrl: string;
};

const InfrastructureNavCards: FC<Props> = ({
    cards,
    baseUrl,
}) => {
    return (
        <div className="row justify-content-center w-100 g-10">
            <div className="col-md-11">
                <div
                    className={`row row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-${cards.length} justify-content-center g-10 text-center inner-department-card`}
                >
                    {cards.map((card) => (
                        <div className="col" key={card.id}>
                            <Link
                                to={`${baseUrl}#${card.id}`}
                                className="text-decoration-none d-block h-100"
                                aria-label={card.title}
                            >
                                <div className="ct-flip-card-front h-100">
                                    <h6>{card.title}</h6>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InfrastructureNavCards;